const LIST_ITEM_CHILD_POSITION = 0;
const LIST_ITEM_LIST_POSITION = 1;
export {
  LIST_ITEM_CHILD_POSITION,
  LIST_ITEM_LIST_POSITION
};
//# sourceMappingURL=constants.js.map